import { Spinner } from '@design-system';

import { AddressForm } from '../../../../features/profile/components/addresses/AddressForm';
import {
  GeneratedAddress,
  useUpdateAddressMutation,
} from '../../../../types/generated';

interface Props {
  addresses: GeneratedAddress[];
  selectedAddress?: string;
  onAddressUpdate: (addressId: string) => Promise<void>;
  onCancel: () => void;
}

export const EditShippingAddress = ({
  addresses,
  onAddressUpdate,
  onCancel,
  selectedAddress,
}: Props) => {
  const [updateAddressMutation, { error, loading }] = useUpdateAddressMutation({
    errorPolicy: 'all',
  });

  const address = addresses.find((a) => a.id === selectedAddress);

  if (!address) {
    return (
      <div className="flex aspect-[1/1] w-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <AddressForm
      address={address}
      error={Boolean(error)}
      loading={loading}
      onCancel={onCancel}
      onUpdate={async (changes) => {
        const res = await updateAddressMutation({
          variables: { addressId: address.id, changes },
        });
        if (res.data?.updateAddress.id) {
          await onAddressUpdate(res.data.updateAddress.id);
        }
      }}
      variant="UPDATE_SHIPPING"
    />
  );
};
